export const reviewsLandingData = [
	{
		icon: '🔹',
		subtitle: 'reviews_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'reviews_subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'reviews_subtitle3',
	},
];
